import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { toast } from "react-toastify";

import * as settingsActions from "store/entities/settingsInfo/action";

import FormDrawer from 'components/__new/common/form-drawer';
import { ButtonLoader, Input, SelectInput } from "components/__new/common/form";
import validate from "utils/validate";
import { capitalizeFirstLetter } from 'utils/stringFormatter';
import processParams from "utils/processParams";
import useUrlQueryParams from "hooks/useUrlQueryParams";



const TeamsFilterModal = (props) => {
const {isOpen, setIsOpen, listParams, setListParams} = props;
const dispatch = useDispatch()
const { getRolesLoading, getRoles, inviteMemberLoading, inviteMember  } = useSelector(state => state.entities.settingsInfo)
const {urlQueryParams} = useUrlQueryParams();

const [isFiltered, setIsFiltered] = useState(false)

// console.log(getRoles)

// const initialRoles = [
//     {
//         id: 1,
//         role: {
//             name: 'Owner',
//             description: 'The ideal user for this role would be the company owner or an executive team member who needs complete admin access.',
//             permissions: ['edit-transaction', 'view-data']
//         },
//     },
//     {
//         id: 2,
//         role: {
//             name: 'Operations',
//             description: 'Team members who can make transfers and require access to people and beneficiary lists will find this to be most effective.',
//             permissions: ['edit-transaction', 'view-data']
//         },
//     },
//     {
//         id: 3,
//         role: {
//             name: 'Customer Support',
//             description: 'Support employees that need full read access and authorization to carry out tasks like refunds and dispute resolutions are the target audience for this function.',
//             permissions: ['edit-transaction', 'view-data']
//         },
//     },
//     {
//         id: 4,
//         role: {
//             name: 'Viewer',
//             description: 'Team members that need to access dashboard elements including payments, balance, businesses, and subaccounts but are unable to alter any of them should use this position. Reports can also be downloaded by this position. ',
//             permissions: ['edit-transaction', 'view-data']
//         },
//     },
//     {
//         id: 5,
//         role: {
//             name: 'Admin',
//             description: "Team members who need complete administrative access are the best candidates for this post.", 
//             permissions: ['edit-transaction', 'view-data']
//         },
//     }
// ]

const statusOptions = [
    {
        id: 1,
        name: 'active',
        value: 'active',
    },
    {
        id: 2,
        name: 'inactive',
        value: 'deactivated',
    },
]

const [form, setForm] = useState({
    role: "",
    status: "",
    
});

const submitForm = async (e) => {
    e.preventDefault();
    
    const validateForm = {...form};
        delete validateForm["role"];
        delete validateForm["status"];
    
    const errors = validate(validateForm);
    if (errors){
        for (var x in errors) {
            toast.error(errors[x]);
        };
        return;
    }
    else{
        const newParams = {
            role: form.role,
            status: form.status,
        }
        
        let params = {...listParams};
        setListParams({...params, ...newParams});  
        
        dispatch(settingsActions.getAllMembers({...params, roleId: form.role, status: form.status}));
        // console.log('newParams::', {...params, role: form.role, status: form.status})
        setIsFiltered(true)
    }
}


useEffect(() => {
    if(isFiltered ){
        setIsFiltered(false)
        setIsOpen(prev => !prev)
    }
}, [isFiltered, setIsOpen]);


    return (
        <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form className="p-6" onSubmit={submitForm}>
                <FormDrawer.Title
                    // title="Edit On-Demand Pay Configuration"
                    // description="Filter By"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                <p className='text-[#101828] font-medium text-[16px] leading-[22px] -mt-6'>Filter By</p>

                <hr className='my-3'/>
                    
                <div className='py-4 text-ep-gray-700 font-medium'>
                    <div className="relative">
                        <div className='absolute top-0 right-0 '>
                            <button type='button' onClick={() => setForm({...form, role: ""})} className="text-ep-primary text-sm font-medium">
                                Reset
                            </button>
                        </div>
                                    {/* <SelectInput label="Role" name="role" value={form.role} onChange={(e) => setForm({...form, role: e.target.value})}>
                                        <option value="">Select a role</option>
                                        {initialRoles?.map(roles => (
                                            <option key={roles.id} value={roles.role?.name} className='capitalize'>{roles.role?.name}</option>
                                        ))}
                                    </SelectInput> */}
                        {(getRolesLoading === true) && 
                                    <Input type="text" label="Role"  value="Loading roles..." disabled={true} />
                                }
                                {(getRolesLoading === false) && 
                                    <SelectInput label="Role" name="role" value={form.role} onChange={(e) => setForm({...form, role: e.target.value})}>
                                        <option value="">Select a Role</option>
                                        {getRoles?.data?.data?.map(role => (
                                            <option key={role.id} value={role.id}>{role.name}</option>
                                        ))}
                                    </SelectInput>
                                    }
                    </div>
                    <div className="relative">
                        <div className='absolute top-0 right-0 '>
                            <button type='button' onClick={(e) => setForm({...form, status: ""})} className="text-ep-primary text-sm font-medium">
                                Reset
                            </button>
                        </div>
                            <SelectInput label="Status" name="status" value={form.status} onChange={(e) => setForm({...form, status: e.target.value})}>
                                <option value="">Select a Status</option>
                                {statusOptions?.map((status) => (
                                    <option key={status.id} value={status.value} className='capitalize'>{capitalizeFirstLetter(status.name)}</option>
                                ))
                                }
                            </SelectInput>
                    </div>
                </div>
                <div className="p-1 mt-4 flex justify-end space-x-3">
                    <button onClick={setIsOpen} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                        Apply
                    </button>
                </div>
                
            </form>
        </FormDrawer>
  )
}

export default TeamsFilterModal